import {Product} from "@app/core/product/domain/dtos/product";
import {Observable} from "rxjs";

export abstract class PdfCatalogRepo {

    public abstract getProducts(): Observable<Product[]>;

    public abstract getPdfApiUrl(showPrice: boolean): Promise<string>;

    public abstract addProduct(product: Product): void;

    public abstract removeProduct(productCode: string): void;

    public abstract removeAllProduct(): void;

    public abstract downloadPdf(url: string): Observable<Blob>;
}
